import React from 'react';

import './DonationRequests.css'


const DonationDetailsModal = ({ donation, onClose }) => {
  return (
    <div className="modal-overlay-donation">
      <div className="modal-content-donation">
        <h2>Donation Details</h2>
        <p><strong>Hospital Name:</strong> {donation.hospital_name}</p>
        <p><strong>Medicine:</strong> {donation.medicine}</p>
        <p><strong>Quantity Needed:</strong> {donation.quantity_needed}</p>
        <p><strong>Reason:</strong> {donation.reason}</p>
        <p><strong>Location:</strong> {donation.location}</p>
        <p><strong>Created At:</strong> {new Date(donation.created_at).toLocaleDateString()}</p>
        <p><strong>Contact Info:</strong></p>
        <p>Phone: {donation.contact_info.phone}</p>
        <p>Email: {donation.contact_info.email}</p>
        
        <button className='CustomButton' onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default DonationDetailsModal;
